import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'
import Parcel from './parcel'
import Article from './article'
import { partition } from '../../../utils/partition'
import { buildServoOrderUrl } from '../../../utils/servo-url'

/**
 * Render Parcels (both Scannable Parcels and Non-scannable "Articles")
 */
export default class Parcels extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    renderParcel = (parcel) => {
        const {
            orderToken,
            merchant,
            deliveryAddress,
            recalledParcel,
            fetchScanEvents,
            loadingScanEvents,
            loadingScanEventsFailed,
            barcodeScanEvents,
        } = this.props
        const header = (
            <div className="clearfix">
                <span title={`id:${parcel.id}`}>Parcel: {parcel.packageId}</span>
                <a
                    href={buildServoOrderUrl(orderToken, parcel.packageId)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-xs btn-default pull-right"
                >
                    Open in Servo
                </a>
            </div>
        )

        return (
            <Panel header={header} key={parcel.id}>
                <Parcel
                    parcel={parcel}
                    merchant={merchant}
                    deliveryAddress={deliveryAddress}
                    recalledParcel={recalledParcel}
                    fetchScanEvents={fetchScanEvents}
                    loadingScanEvents={loadingScanEvents}
                    loadingScanEventsFailed={loadingScanEventsFailed}
                    barcodeScanEvents={barcodeScanEvents}
                />
            </Panel>
        )
    }

    renderArticle = (article) => {
        const { deliveryAddress } = this.props
        const header = <span>Article: {article.title} </span>

        return (
            <Panel header={header} key={article.id}>
                <Article deliveryAddress={deliveryAddress} article={article} />
            </Panel>
        )
    }

    render() {
        const { parcels: allParcels } = this.props
        if (allParcels === null) {
            return null
        }

        const [parcels, articles] = partition(allParcels, (p) => p.title == null)

        return (
            <div>
                {parcels.map(this.renderParcel)}
                {articles.map(this.renderArticle)}
            </div>
        )
    }
}

Parcels.propTypes = {
    orderToken: PropTypes.string.isRequired,
    merchant: PropTypes.object.isRequired,
    deliveryAddress: PropTypes.object.isRequired,
    parcels: PropTypes.array.isRequired,
    recalledParcel: PropTypes.func.isRequired,
    fetchScanEvents: PropTypes.func.isRequired,
    loadingScanEvents: PropTypes.bool.isRequired,
    loadingScanEventsFailed: PropTypes.bool.isRequired,
    barcodeScanEvents: PropTypes.array.isRequired,
}
